import {TrusteeLink} from '../beneficiaries/trustee-link';
import {Dropdown} from './dropdown';

const TRUSTEE_LINK_OPTIONS_FR: Dropdown<TrusteeLink>[] = [
  {name: 'Employé', value: TrusteeLink.EMPLOYEE},
  {name: 'Actionnaire', value: TrusteeLink.SHAREHOLDER},
  {name: 'Personne clé', value: TrusteeLink.KEY_PERSON},
  {name: 'Partenaire', value: TrusteeLink.PARTNER},
  {name: 'Père', value: TrusteeLink.FATHER},
  {name: 'Mère', value: TrusteeLink.MOTHER},
  {name: 'Soeur', value: TrusteeLink.SISTER},
  {name: 'Frère', value: TrusteeLink.BROTHER},
];

const TRUSTEE_LINK_OPTIONS_EN: Dropdown<TrusteeLink>[] = [
  {name: 'Employee', value: TrusteeLink.EMPLOYEE},
  {name: 'Shareholder', value: TrusteeLink.SHAREHOLDER},
  {name: 'Key Person', value: TrusteeLink.KEY_PERSON},
  {name: 'Partner', value: TrusteeLink.PARTNER},
  {name: 'Father', value: TrusteeLink.FATHER},
  {name: 'Mother', value: TrusteeLink.MOTHER},
  {name: 'Sister', value: TrusteeLink.SISTER},
  {name: 'Brother', value: TrusteeLink.BROTHER},
];

export const TRUSTEE_LINK_OPTIONS = {
  en: TRUSTEE_LINK_OPTIONS_EN,
  fr: TRUSTEE_LINK_OPTIONS_FR,
};
